import { ApolloClient, InMemoryCache } from '@apollo/client';
import { from as chainLinks } from '@apollo/client/link/core';
import { onError } from '@apollo/client/link/error';
import { HttpLink } from '@apollo/client/link/http';
import possibleTypes from '@atlassian/mpac-types/dist/GraphQLGateway.possibleTypes.gen.json';
import { log } from '@atlassian/mpac-utils';
var ERROR_LINK_LOG_PREFIX = '[Apollo GraphQL]';

var createApolloCache = function createApolloCache() {
  return new InMemoryCache({
    possibleTypes: possibleTypes,
    typePolicies: {
      // Workaround for this apollo bug: github.com/apollographql/apollo-client/issues/7636
      // by disabling caching for this field (https://bit.ly/371l02H)
      CompatibleAtlassianProduct: {
        keyFields: false
      }
    }
  });
};
/**
 * Compose links for apollo
 * @see https://www.apollographql.com/docs/react/api/link/introduction/#composing-a-link-chain
 */


var createApolloLinks = function createApolloLinks(uri) {
  // error link to capture & report errors in a single place
  // see: https://www.apollographql.com/docs/react/api/link/apollo-link-error/
  var errorLink = onError(function (_ref) {
    var graphQLErrors = _ref.graphQLErrors,
        networkError = _ref.networkError,
        operation = _ref.operation;

    if (graphQLErrors) {
      graphQLErrors.forEach(function (_ref2) {
        var message = _ref2.message;
        log.error(ERROR_LINK_LOG_PREFIX, "Operation \"".concat(operation.operationName, "\" failed"), {
          extraInfo: {
            message: message,
            variables: operation.variables
          }
        });
      });
    }

    if (networkError) {
      log.error(ERROR_LINK_LOG_PREFIX, "Network error in operation \"".concat(operation.operationName, "\""), {
        error: networkError,
        extraInfo: {
          message: networkError.message,
          variables: operation.variables,
          statusCode: networkError.statusCode
        }
      });
    }
  });
  return chainLinks([errorLink, // httpLink must be the last one since it is a terminating link
  new HttpLink({
    uri: uri,
    credentials: 'include'
  })]);
};

export var createApolloClient = function createApolloClient(uri) {
  return new ApolloClient({
    cache: createApolloCache(),
    link: createApolloLinks(uri)
  });
};